import { StepSchema } from '@feedyou/schema'
import { FeedbotThunk } from '../../store/types'
import { STEP_ACTION } from '../../constants/actionTypes'
import { getSelectedMutationsSelector } from '../../store/selectedMutations/selectors'
import { parentDialogIdForStepSelector } from '../../store/dialog/selectors'
import { dialogsSelector } from '../../store/flow/selectors/dialogsSelector'

export function stepAction(stepId: string, stepAction: any): FeedbotThunk {
  return (dispatch, getState) => {
    const state = getState()

    const dialogs = dialogsSelector(state)
    const selectedMutations = getSelectedMutationsSelector(state)
    const dialogId = parentDialogIdForStepSelector(stepId)(state)

    if (!dialogId) {
      return
    }

    const stepIndex = dialogs[dialogId].steps.findIndex((step: StepSchema) => step.id === stepId)

    dispatch({
      type: STEP_ACTION,
      dialogId,
      stepIndex,
      stepAction,
      selectedMutations
    })
  }
}

export const CREATE_NEW_DIALOG = Symbol('CREATE_NEW_DIALOG')
